interface AddOn {
  icon: string;
  title: string;
  description: string;
}

const addOns: AddOn[] = [
  {
    icon: "ri-presentation-line",
    title: "Additional Training Sessions",
    description: "Extended role-based training beyond standard onboarding for new hires, refresher courses, or advanced feature adoption.",
  },
  {
    icon: "ri-database-2-line",
    title: "Data Migration",
    description: "Structured migration of your existing data from legacy systems, spreadsheets, or other platforms into StackMap with full validation.",
  },
  {
    icon: "ri-link-m",
    title: "Custom Integrations",
    description: "Bespoke API connections to third-party tools, ERPs, payment gateways, or proprietary systems that your business relies on.",
  },
  {
    icon: "ri-user-star-line",
    title: "Dedicated Account Manager",
    description: "A single point of contact who knows your business, monitors your usage, and proactively recommends optimisations.",
  },
  {
    icon: "ri-time-line",
    title: "Extended Support Hours",
    description: "Support coverage beyond standard business hours, including weekends and holidays for mission-critical operations.",
  },
  {
    icon: "ri-pie-chart-2-line",
    title: "Bespoke Reporting",
    description: "Custom dashboards and reports built to your exact specifications, combining data across modules for executive visibility.",
  },
  {
    icon: "ri-code-box-line",
    title: "Custom Development Services",
    description: "Tailored feature development, custom modules, or entirely new applications built on top of the StackMap platform.",
  },
];

export default function AddOnServices() {
  return (
    <section className="relative py-16 md:py-24 bg-graphite-900">
      <div className="section-padding">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              Add-On{" "}
              <span className="text-emerald-accent">Services</span>
            </h2>
            <p className="text-base sm:text-lg text-silver-300 max-w-2xl mx-auto leading-relaxed mb-3">
              Extend your StackMap experience with optional services tailored to your operational needs.
            </p>
            <p className="text-xs text-silver-500">
              Availability of add-on services may vary depending on your selected package.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {addOns.map((addon) => (
              <div
                key={addon.title}
                className="glass-card p-5 md:p-6 flex items-start gap-4 group"
              >
                <div className="w-10 h-10 flex items-center justify-center shrink-0 rounded-xl bg-emerald-accent/10 border border-emerald-accent/20">
                  <i className={`${addon.icon} text-emerald-accent text-lg`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold text-white mb-1.5">{addon.title}</h4>
                  <p className="text-xs text-silver-400 leading-relaxed">{addon.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}